import React, { useEffect, useRef, useState } from "react";
import { nowOf } from "@/lib/stages";
import { ukDayTime } from "@/lib/time";

const CHECK_AFTER_MS = 60 * 60 * 1000;
const NEXT = [["clear", "Carry on assessing"], ["credit", "With our credit team"], ["valuation", "Waiting on valuation or searches"]];

/** An hour after a booked call, still on "Call back booked" — the desk hasn't said how it went. */
export const callDue = (r) => {
  const n = nowOf(r);
  return !!(n?.key === "callback" && n.callback_at && Date.now() - new Date(n.callback_at).getTime() >= CHECK_AFTER_MS);
};

/**
 * "Did the call happen?" — Yes picks the next Right now update, No answer moves to Trying to reach the client,
 * Moved books a new time. `auto` is the answer tapped in the email (?call=spoke|no_answer|moved).
 */
export function CallCheck({ row, client, onPick, onClear, auto, onAuto, compact, testId = "call-check" }) {
  const [spoke, setSpoke] = useState(false);
  const fired = useRef(false);
  const due = callDue(row);

  useEffect(() => {
    if (!auto || fired.current) return;
    fired.current = true;
    if (due) {
      if (auto === "spoke") setSpoke(true);
      else if (auto === "no_answer") onPick("no_contact");
      else if (auto === "moved") onPick("callback");
    }
    onAuto?.();
  }, [auto, due, onPick, onAuto]);

  if (!due) return null;
  return (
    <div className={`callchk${compact ? " sm" : ""}`} role="status" data-testid={testId} onClick={(e) => e.stopPropagation()}>
      <div className="callchk-q" data-testid={`${testId}-question`}>
        Did the call{client ? ` with ${client}` : ""} at {ukDayTime(row.callback_at, "the booked time")} happen?
      </div>
      {!spoke ? (
        <div className="callchk-acts">
          <button className="yes" onClick={() => setSpoke(true)} data-testid={`${testId}-spoke`}>Yes, we spoke</button>
          <button onClick={() => onPick("no_contact")} data-testid={`${testId}-no-answer`}>No answer</button>
          <button onClick={() => onPick("callback")} data-testid={`${testId}-moved`}>Moved to another time</button>
        </div>
      ) : (
        <>
          <div className="callchk-sub" data-testid={`${testId}-next-title`}>Good. What&apos;s happening now? The introducer sees it straight away.</div>
          <div className="callchk-acts">
            {NEXT.map(([k, t]) => (
              <button key={k} className={k === "clear" ? "yes" : undefined} onClick={() => (k === "clear" ? onClear() : onPick(k))}
                      data-testid={`${testId}-next-${k}`}>{t}</button>
            ))}
            <button className="back" onClick={() => setSpoke(false)} data-testid={`${testId}-back`}>Back</button>
          </div>
          {!compact && <div className="callchk-note">Ready to decide? Use the stage menu at the top to issue an offer or pass.</div>}
        </>
      )}
    </div>
  );
}

export default CallCheck;
